import find from './find'
import update from './update'
import fetchPermissionsInfo from './fetchPermissionsInfo'
import fetchGroupInfo from './fetchGroupInfo'
import updateAccountLevel from './updateAccountLevel'

export default {
  find,
  update,
  fetchPermissionsInfo,
  fetchGroupInfo,
  updateAccountLevel
}



// WEBPACK FOOTER //
// ./src/services/account/index.js